export const setOutdated = () => ({ type: 'UPDATES_SET_OUTDATED' });
